import { createContext, useContext, useEffect } from 'react';
import type { BreadcrumbItem } from './breadcrumbTrail';

type RegisterTrail = (trail: BreadcrumbItem[] | null) => void;

export const BreadcrumbContext = createContext<RegisterTrail>(() => undefined);

export const useBreadcrumbs = (trail: BreadcrumbItem[]) => {
  const register = useContext(BreadcrumbContext);
  const key = JSON.stringify(trail);

  useEffect(() => {
    register(JSON.parse(key) as BreadcrumbItem[]);
    return () => register(null);
  }, [key, register]);
};
